<ion-header>
  <ion-toolbar color="primary">
    <ion-title class="ion-text-center">
      Seleccionar nuevo archivo
    </ion-title>
    <ion-buttons slot="end" class="buttons-end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <input type="file"
    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    (change)="selectFile($event)" />
</ion-content>
<ion-footer>
  <ion-toolbar color="primary">
    <ion-buttons slot="end">
      <ion-button (click)="send()" [disabled]="!!!file">
        <ion-icon slot="end" name="send"></ion-icon>
        Reenviar chats
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>